import { render, staticRenderFns } from "./EmpresaGrupo.vue?vue&type=template&id=9c373476&scoped=true"
import script from "./EmpresaGrupo.vue?vue&type=script&lang=js"
export * from "./EmpresaGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c373476",
  null
  
)

export default component.exports